import sharing from '@/api/sharing'
import { mergeUserContext } from '@/store/helpers'

// initial state
const state = {
  sharePersonRecords: [],
  sharePersonResponse: false,
  unsharePersonResponse: false,

  shareAdvocateRecords: [],
  shareAdvocateResponse: false,
  unshareAdvocateResponse: false,

  shareNoteRecords: [],
  shareNoteResponse: '',
  unshareNoteResponse: false,

  shareAssessmentRecords: [],
  shareAssessmentResponse: '',
  unshareAssessmentResponse: false,

  shareCseitRecords: [],
  shareCseitResponse: '',
  unshareCseitResponse: false,

  shareLaborScreeningRecords: [],
  shareLaborScreeningResponse: '',
  unshareLaborScreeningResponse: false,

  shareTraffickingScreeningRecords: [],
  shareTraffickingScreeningResponse: '',
  unshareTraffickingScreeningResponse: false
}

const getters = {
  sharePersonRecords: state => state.sharePersonRecords,
  sharePersonResponse: state => state.sharePersonResponse,
  unsharePersonResponse: state => state.unsharePersonResponse,

  shareAdvocateRecords: state => state.shareAdvocateRecords,
  shareAdvocateResponse: state => state.shareAdvocateResponse,
  unshareAdvocateResponse: state => state.unshareAdvocateResponse,

  shareNoteRecords: state => state.shareNoteRecords,
  shareNoteResponse: state => state.shareNoteResponse,
  unshareNoteResponse: state => state.unshareNoteResponse,

  shareAssessmentRecords: state => state.shareAssessmentRecords,
  shareAssessmentResponse: state => state.shareAssessmentResponse,
  unshareAssessmentResponse: state => state.unshareAssessmentResponse,

  shareCseitRecords: state => state.shareCseitRecords,
  shareCseitResponse: state => state.shareCseitResponse,
  unshareCseitResponse: state => state.unshareCseitResponse,

  getShareLaborScreeningRecords: state => state.shareLaborScreeningRecords,
  getShareLaborScreeningResponse: state => state.shareLaborScreeningResponse,
  getUnshareLaborScreeningResponse: state => state.unshareLaborScreeningResponse,

  getShareTraffickingScreeningRecords: state => state.shareTraffickingScreeningRecords,
  getShareTraffickingScreeningResponse: state => state.shareTraffickingScreeningResponse,
  getUnshareTraffickingScreeningResponse: state => state.unshareTraffickingScreeningResponse
}

const actions = {
  async getSharePersonRecords ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    let response = await sharing.getSharePersonRecords(payload)
    response = response.body

    commit('SET_SHARE_PERSON_RECORDS', response.filter((s) => s.personShareStatus))
  },

  async sharePerson ({ commit, state, rootState }, payload) {
    let response = await sharing.sharePerson(payload)
    response = response.body

    if (response.success) {
      commit('ADD_SHARE_PERSON_RECORD', response.data)
    }
    commit('SET_SHARE_PERSON_RESPONSE', response)
  },

  async unsharePerson ({ commit, state, rootState }, payload) {
    let response = await sharing.unsharePerson(payload)
    response = response.body

    if (response.success) {
      commit('UPDATE_SHARE_PERSON_RECORD', response.data)
    }
    commit('SET_UNSHARE_PERSON_RESPONSE', response)
  },

  async getShareAdvocateRecords ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    let response = await sharing.getShareAdvocateRecords(payload)
    response = response.body

    commit('SET_SHARE_ADVOCATE_RECORDS', response.filter((a) => a.advocateShareStatus))
  },

  async shareAdvocate ({ commit, state, rootState }, payload) {
    let response = await sharing.shareAdvocate(payload)
    response = response.body

    if (response.success) {
      commit('ADD_SHARE_ADVOCATE_RECORD', response.data)
    }
    commit('SET_SHARE_ADVOCATE_RESPONSE', response)
  },

  async unshareAdvocate ({ commit, state, rootState }, payload) {
    let response = await sharing.unshareAdvocate(payload)
    response = response.body

    if (response.success) {
      commit('UPDATE_SHARE_ADVOCATE_RECORD', response.data)
    }
    commit('SET_UNSHARE_ADVOCATE_RESPONSE', response)
  },

  async getShareNoteRecords ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    let response = await sharing.getShareNoteRecords(payload)
    response = response.body

    commit('SET_SHARE_NOTE_RECORDS', response.filter(n => n.noteShareStatus))
  },

  async shareNote ({ commit, state, rootState }, payload) {
    let response = await sharing.shareNote(payload)
    response = response.body

    if (response.success) {
      commit('ADD_SHARE_NOTE_RECORD', response.data)
    }
    commit('SET_SHARE_NOTE_RESPONSE', response)
  },

  async unshareNote ({ commit, state, rootState }, payload) {
    let response = await sharing.unshareNote(payload)
    response = response.body

    if (response.success) {
      commit('UPDATE_SHARE_NOTE_RECORD', response.data)
    }
    commit('SET_UNSHARE_NOTE_RESPONSE', response)
  },

  async getShareAssessmentRecords ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    let response = await sharing.getShareAssessmentRecords(payload)
    response = response.body

    commit('SET_SHARE_ASSESSMENT_RECORDS', response.filter(a => a.assessmentShareStatus))
  },

  async shareAssessment ({ commit, state, rootState }, payload) {
    let response = await sharing.shareAssessment(payload)
    response = response.body

    if (response.success) {
      commit('ADD_SHARE_ASSESSMENT_RECORD', response.data)
    }
    commit('SET_SHARE_ASSESSMENT_RESPONSE', response)
  },

  async unshareAssessment ({ commit, state, rootState }, payload) {
    let response = await sharing.unshareAssessment(payload)
    response = response.body

    if (response.success) {
      commit('UPDATE_SHARE_ASSESSMENT_RECORD', response.data)
    }
    commit('SET_UNSHARE_ASSESSMENT_RESPONSE', response)
  },

  async getShareCseitRecords ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    let response = await sharing.getShareCseitRecords(payload)
    response = response.body

    commit('SET_SHARE_CSEIT_RECORDS', response.filter((c) => c.cseitShareStatus))
  },

  async shareCseit ({ commit, state, rootState }, payload) {
    let response = await sharing.shareCseit(payload)
    response = response.body
    console.log(payload)

    if (response.success) {
      commit('ADD_SHARE_CSEIT_RECORD', response.data)
    }
    commit('SET_SHARE_CSEIT_RESPONSE', response)
  },

  async unshareCseit ({ commit, state, rootState }, payload) {
    let response = await sharing.unshareCseit(payload)
    response = response.body

    if (response.success) {
      commit('UPDATE_SHARE_CSEIT_RECORD', response.data)
    }
    commit('SET_UNSHARE_CSEIT_RESPONSE', response)
  },

  async getShareLaborScreeningRecords ({ commit, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    const response = await sharing.getShareLaborScreeningRecords(payload)
    commit('SET_SHARE_LABOR_SCREENING_RECORDS', response.body.filter((ls) => ls.laborScreeningShareStatus))
  },

  async shareLaborScreening ({ commit }, payload) {
    let response = await sharing.shareLaborScreening(payload)
    if (response.success) {
      commit('ADD_SHARE_LABOR_SCREENING_RECORD', response.data)
    }
    commit('SET_SHARE_LABOR_SCREENING_RESPONSE', response)
  },

  async unshareLaborScreening ({ commit }, payload) {
    let response = await sharing.unshareLaborScreening(payload)
    if (response.success) {
      commit('UPDATE_SHARE_LABOR_SCREENING_RECORD', response.data)
    }
    commit('SET_UNSHARE_LABOR_SCREENING_RESPONSE', response)
  },

  async getShareTraffickingScreeningRecords ({ commit, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    const response = await sharing.getShareTraffickingScreeningRecords(payload)
    commit('SET_SHARE_TRAFFICKING_SCREENING_RECORDS', response.body.filter((ts) => ts.traffickingScreeningShareStatus))
  },

  async shareTraffickingScreening ({ commit }, payload) {
    let response = await sharing.shareTraffickingScreening(payload)
    if (response.success) {
      commit('ADD_SHARE_TRAFFICKING_SCREENING_RECORD', response.data)
    }
    commit('SET_SHARE_TRAFFICKING_SCREENING_RESPONSE', response)
  },

  async unshareTraffickingScreening ({ commit }, payload) {
    let response = await sharing.unshareTraffickingScreening(payload)
    if (response.success) {
      commit('UPDATE_SHARE_TRAFFICKING_SCREENING_RECORD', response.data)
    }
    commit('SET_UNSHARE_TRAFFICKING_SCREENING_RESPONSE', response)
  }
}

const mutations = {
  // Person
  ADD_SHARE_PERSON_RECORD (state, response) {
    const existingIndex = state.sharePersonRecords.findIndex((r) => r.id === response.id)
    if (existingIndex >= 0) {
      state.sharePersonRecords.splice(existingIndex, 1, response)
    } else {
      state.sharePersonRecords.push(response)
    }
  },

  SET_SHARE_PERSON_RECORDS (state, response) {
    state.sharePersonRecords = response
  },

  SET_SHARE_PERSON_RESPONSE (state, response) {
    const formattedResponse = this._vm.$utils.responseHandler(response)
    state.sharePersonResponse = formattedResponse
  },

  RESET_SHARE_PERSON_RECORDS (state, response) {
    state.sharePersonRecords = []
  },

  UPDATE_SHARE_PERSON_RECORD (state, response) {
    let existingIndex = state.sharePersonRecords.findIndex((r) => r.id === response.id)
    if (!response.personShareStatus) {
      state.sharePersonRecords.splice(existingIndex, 1)
      return
    }

    if (existingIndex >= 0) {
      state.sharePersonRecords.splice(existingIndex, 1, response)
    } else {
      state.sharePersonRecords.push(response)
    }
  },

  SET_UNSHARE_PERSON_RESPONSE (state, response) {
    const formattedResponse = this._vm.$utils.responseHandler(response)
    state.unsharePersonResponse = formattedResponse
  },

  // Assessment
  ADD_SHARE_ASSESSMENT_RECORD (state, payload) {
    const existingIndex = state.shareAssessmentRecords.findIndex((r) => r.id === payload.id)
    if (existingIndex >= 0) {
      state.shareAssessmentRecords.splice(existingIndex, 1, payload)
    } else {
      state.shareAssessmentRecords.push(payload)
    }
  },

  SET_SHARE_ASSESSMENT_RECORDS (state, response) {
    state.shareAssessmentRecords = response
  },

  SET_SHARE_ASSESSMENT_RESPONSE (state, response) {
    const formattedResponse = this._vm.$utils.responseHandler(response)
    state.shareAssessmentResponse = formattedResponse
  },

  RESET_SHARE_ASSESSMENT_RECORDS (state, response) {
    state.shareAssessmentRecords = []
  },

  UPDATE_SHARE_ASSESSMENT_RECORD (state, response) {
    let existingIndex = state.shareAssessmentRecords.findIndex((r) => r.id === response.id)

    if (existingIndex >= 0) {
      state.shareAssessmentRecords.splice(existingIndex, 1, response)
    } else {
      state.shareAssessmentRecords.push(response)
    }
  },

  SET_UNSHARE_ASSESSMENT_RESPONSE (state, response) {
    const formattedResponse = this._vm.$utils.responseHandler(response)
    state.unshareAssessmentResponse = formattedResponse
  },

  // Advocate
  ADD_SHARE_ADVOCATE_RECORD (state, response) {
    let existingIndex = state.shareAdvocateRecords.findIndex((r) => r.id === response.id)

    if (existingIndex >= 0) {
      state.shareAdvocateRecords.splice(existingIndex, 1, response)
    } else {
      state.shareAdvocateRecords.push(response)
    }
  },

  SET_SHARE_ADVOCATE_RECORDS (state, response) {
    state.shareAdvocateRecords = response
  },

  SET_SHARE_ADVOCATE_RESPONSE (state, response) {
    const formattedResponse = this._vm.$utils.responseHandler(response)
    state.shareAdvocateResponse = formattedResponse
  },

  RESET_SHARE_ADVOCATE_RECORDS (state, response) {
    state.shareAdvocateRecords = []
  },

  UPDATE_SHARE_ADVOCATE_RECORD (state, response) {
    let existingIndex = state.shareAdvocateRecords.findIndex((r) => r.id === response.id)

    if (existingIndex >= 0) {
      state.shareAdvocateRecords.splice(existingIndex, 1, response)
    } else {
      state.shareAdvocateRecords.push(response)
    }
  },

  SET_UNSHARE_ADVOCATE_RESPONSE (state, response) {
    const formattedResponse = this._vm.$utils.responseHandler(response)
    state.unshareAdvocateResponse = formattedResponse
  },

  // Note
  ADD_SHARE_NOTE_RECORD (state, response) {
    let existingIndex = state.shareNoteRecords.findIndex((r) => r.id === response.id)

    if (existingIndex >= 0) {
      state.shareNoteRecords.splice(existingIndex, 1, response)
    } else {
      state.shareNoteRecords.push(response)
    }
  },

  SET_SHARE_NOTE_RECORDS (state, response) {
    state.shareNoteRecords = response
  },

  SET_SHARE_NOTE_RESPONSE (state, response) {
    const formattedResponse = this._vm.$utils.responseHandler(response)
    state.shareNoteResponse = formattedResponse
  },

  RESET_SHARE_NOTE_RECORDS (state, response) {
    state.shareNoteRecords = []
  },

  UPDATE_SHARE_NOTE_RECORD (state, response) {
    let existingIndex = state.shareNoteRecords.findIndex((r) => r.id === response.id)

    if (existingIndex >= 0) {
      state.shareNoteRecords.splice(existingIndex, 1, response)
    } else {
      state.shareNoteRecords.push(response)
    }
  },

  SET_UNSHARE_NOTE_RESPONSE (state, response) {
    const formattedResponse = this._vm.$utils.responseHandler(response)
    state.unshareNoteResponse = formattedResponse
  },

  // Cseit
  ADD_SHARE_CSEIT_RECORD (state, payload) {
    const existingIndex = state.shareCseitRecords.findIndex((r) => r.id === payload.id)
    if (existingIndex >= 0) {
      state.shareCseitRecords.splice(existingIndex, 1, payload)
    } else {
      state.shareCseitRecords.push(payload)
    }
  },

  SET_SHARE_CSEIT_RECORDS (state, response) {
    state.shareCseitRecords = response
  },

  SET_SHARE_CSEIT_RESPONSE (state, response) {
    const formattedResponse = this._vm.$utils.responseHandler(response)
    state.shareCseitResponse = formattedResponse
  },

  RESET_SHARE_CSEIT_RECORDS (state, response) {
    state.shareCseitRecords = []
  },

  UPDATE_SHARE_CSEIT_RECORD (state, response) {
    let existingIndex = state.shareCseitRecords.findIndex((r) => r.id === response.id)

    if (existingIndex >= 0) {
      state.shareCseitRecords.splice(existingIndex, 1, response)
    } else {
      state.shareCseitRecords.push(response)
    }
  },

  SET_UNSHARE_CSEIT_RESPONSE (state, response) {
    const formattedResponse = this._vm.$utils.responseHandler(response)
    state.unshareCseitResponse = formattedResponse
  },

  RESET_SHARE_RESPONSE (state, response) {
    state[response.name] = ''
  },

  SET_SHARE_LABOR_SCREENING_RECORDS (state, response) {
    state.shareLaborScreeningRecords = response
  },

  ADD_SHARE_LABOR_SCREENING_RECORD (state, payload) {
    const existingIndex = state.shareLaborScreeningRecords.findIndex((r) => r.id === payload.id)
    if (existingIndex >= 0) {
      state.shareLaborScreeningRecords.splice(existingIndex, 1, payload)
    } else {
      state.shareLaborScreeningRecords.push(payload)
    }
  },

  SET_SHARE_LABOR_SCREENING_RESPONSE (state, response) {
    state.shareLaborScreeningResponse = response.body
  },

  UPDATE_SHARE_LABOR_SCREENING_RECORD (state, response) {
    const existingIndex = state.shareLaborScreeningRecords.findIndex((r) => r.id === response.id)
    if (existingIndex >= 0) {
      state.shareLaborScreeningRecords.splice(existingIndex, 1, response)
    } else {
      state.shareLaborScreeningRecords.push(response)
    }
  },

  SET_UNSHARE_LABOR_SCREENING_RESPONSE (state, response) {
    state.unshareLaborScreeningResponse = response.body
  },

  RESET_SHARE_LABOR_SCREENING_RECORDS (state, response) {
    state.shareLaborScreeningRecords = []
  },

  SET_SHARE_TRAFFICKING_SCREENING_RECORDS (state, response) {
    state.shareTraffickingScreeningRecords = response
  },

  ADD_SHARE_TRAFFICKING_SCREENING_RECORD (state, payload) {
    const existingIndex = state.shareTraffickingScreeningRecords.findIndex((r) => r.id === payload.id)
    if (existingIndex >= 0) {
      state.shareTraffickingScreeningRecords.splice(existingIndex, 1, payload)
    } else {
      state.shareTraffickingScreeningRecords.push(payload)
    }
  },

  SET_SHARE_TRAFFICKING_SCREENING_RESPONSE (state, response) {
    state.shareTraffickingScreeningResponse = response.body
  },

  UPDATE_SHARE_TRAFFICKING_SCREENING_RECORD (state, response) {
    const existingIndex = state.shareTraffickingScreeningRecords.findIndex((r) => r.id === response.id)
    if (existingIndex >= 0) {
      state.shareTraffickingScreeningRecords.splice(existingIndex, 1, response)
    } else {
      state.shareTraffickingScreeningRecords.push(response)
    }
  },

  SET_UNSHARE_TRAFFICKING_SCREENING_RESPONSE (state, response) {
    state.unshareTraffickingScreeningResponse = response.body
  },

  RESET_SHARE_TRAFFICKING_SCREENING_RECORDS (state, response) {
    state.shareTraffickingScreeningRecords = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/sharing.js